@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-871_738_790)
public val Res.string.file_drop_only_one: StringResource by lazy {
      StringResource("string:file_drop_only_one", "file_drop_only_one", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140534, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 197926, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127549, 110),
      ))
    }

@delegate:ResourceContentHash(1_539_587_020)
public val Res.string.file_drop_skipped: StringResource by lazy {
      StringResource("string:file_drop_skipped", "file_drop_skipped", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140649, 121),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 198089, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127660, 109),
      ))
    }

@delegate:ResourceContentHash(-933_018_826)
public val Res.string.file_drop_wrong_type: StringResource by lazy {
      StringResource("string:file_drop_wrong_type", "file_drop_wrong_type", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140885, 100),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 198441, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127884, 92),
      ))
    }

@delegate:ResourceContentHash(1_342_335_272)
public val Res.string.file_drop_wrong_types: StringResource by lazy {
      StringResource("string:file_drop_wrong_types", "file_drop_wrong_types", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140771, 113),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 198279, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127770, 113),
      ))
    }

@delegate:ResourceContentHash(-1_531_437_956)
public val Res.string.financials_actual_to_date: StringResource by lazy {
      StringResource("string:financials_actual_to_date", "financials_actual_to_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 140986, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 198590, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127977, 57),
      ))
    }

@delegate:ResourceContentHash(1_632_718_782)
public val Res.string.financials_comparison: StringResource by lazy {
      StringResource("string:financials_comparison", "financials_comparison", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 141048, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 198668, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128035, 49),
      ))
    }

@delegate:ResourceContentHash(688_263_652)
public val Res.string.financials_cost_breakdown: StringResource by lazy {
      StringResource("string:financials_cost_breakdown", "financials_cost_breakdown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 141102, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 198726, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128085, 53),
      ))
    }

@delegate:ResourceContentHash(1_960_759_782)
public val Res.string.financials_empty: StringResource by lazy {
      StringResource("string:financials_empty", "financials_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 141160, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 198804, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128139, 76),
      ))
    }

@delegate:ResourceContentHash(1_577_872_620)
public val Res.string.financials_estimate_note: StringResource by lazy {
      StringResource("string:financials_estimate_note", "financials_estimate_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 141241, 224),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 198929, 388),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128216, 192),
      ))
    }

@delegate:ResourceContentHash(-1_244_705_746)
public val Res.string.financials_fixed_costs: StringResource by lazy {
      StringResource("string:financials_fixed_costs", "financials_fixed_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 141466, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 199318, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128409, 70),
      ))
    }

@delegate:ResourceContentHash(1_309_736_637)
public val Res.string.financials_health: StringResource by lazy {
      StringResource("string:financials_health", "financials_health", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 141545, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 199421, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128480, 69),
      ))
    }

@delegate:ResourceContentHash(-2_039_992_891)
public val Res.string.financials_labor_costs: StringResource by lazy {
      StringResource("string:financials_labor_costs", "financials_labor_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 141867, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 199935, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128810, 46),
      ))
    }

@delegate:ResourceContentHash(714_032_473)
public val Res.string.financials_labor_costs_note: StringResource by lazy {
      StringResource("string:financials_labor_costs_note", "financials_labor_costs_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 141623, 243),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 199515, 419),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128550, 259),
      ))
    }

@delegate:ResourceContentHash(-5_258_184)
public val Res.string.financials_labor_value: StringResource by lazy {
      StringResource("string:financials_labor_value", "financials_labor_value", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 141988, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200128, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128923, 58),
      ))
    }

@delegate:ResourceContentHash(844_922_222)
public val Res.string.financials_labor_value_income: StringResource by lazy {
      StringResource("string:financials_labor_value_income", "financials_labor_value_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 141914, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200014, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128857, 65),
      ))
    }

@delegate:ResourceContentHash(1_261_719_512)
public val Res.string.financials_no_roster: StringResource by lazy {
      StringResource("string:financials_no_roster", "financials_no_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142059, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200223, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128982, 68),
      ))
    }

@delegate:ResourceContentHash(870_414_098)
public val Res.string.financials_other_costs: StringResource by lazy {
      StringResource("string:financials_other_costs", "financials_other_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142128, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200328, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129051, 58),
      ))
    }

@delegate:ResourceContentHash(-1_267_637_359)
public val Res.string.financials_roster: StringResource by lazy {
      StringResource("string:financials_roster", "financials_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142187, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200419, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129110, 41),
      ))
    }

@delegate:ResourceContentHash(1_674_364_149)
public val Res.string.financials_select_roster: StringResource by lazy {
      StringResource("string:financials_select_roster", "financials_select_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142229, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200469, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129152, 52),
      ))
    }

@delegate:ResourceContentHash(277_285_734)
public val Res.string.financials_show_daily_records: StringResource by lazy {
      StringResource("string:financials_show_daily_records", "financials_show_daily_records", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142282, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200538, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129205, 61),
      ))
    }

@delegate:ResourceContentHash(-2_065_553_931)
public val Res.string.financials_show_payroll: StringResource by lazy {
      StringResource("string:financials_show_payroll", "financials_show_payroll", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142348, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200648, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129267, 47),
      ))
    }

@delegate:ResourceContentHash(2_111_985_027)
public val Res.string.financials_total_expenses: StringResource by lazy {
      StringResource("string:financials_total_expenses", "financials_total_expenses", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142396, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200756, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129315, 53),
      ))
    }

@delegate:ResourceContentHash(303_901_245)
public val Res.string.first_steps_dismiss: StringResource by lazy {
      StringResource("string:first_steps_dismiss", "first_steps_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142446, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200826, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129369, 35),
      ))
    }

@delegate:ResourceContentHash(777_677_221)
public val Res.string.first_steps_done: StringResource by lazy {
      StringResource("string:first_steps_done", "first_steps_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142482, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200878, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129405, 32),
      ))
    }

@delegate:ResourceContentHash(-596_545_053)
public val Res.string.first_steps_progress: StringResource by lazy {
      StringResource("string:first_steps_progress", "first_steps_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142519, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200927, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129438, 52),
      ))
    }

@delegate:ResourceContentHash(-1_258_775_867)
public val Res.string.first_steps_to_do: StringResource by lazy {
      StringResource("string:first_steps_to_do", "first_steps_to_do", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142576, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 200996, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129491, 33),
      ))
    }

@delegate:ResourceContentHash(2_123_901_673)
public val Res.string.forecast_accepted: StringResource by lazy {
      StringResource("string:forecast_accepted", "forecast_accepted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142618, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 201042, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129525, 81),
      ))
    }

@delegate:ResourceContentHash(-376_768_586)
public val Res.string.forecast_banner: StringResource by lazy {
      StringResource("string:forecast_banner", "forecast_banner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142708, 171),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 201184, 311),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129607, 143),
      ))
    }

@delegate:ResourceContentHash(-433_440_480)
public val Res.string.forecast_basis_holiday: StringResource by lazy {
      StringResource("string:forecast_basis_holiday", "forecast_basis_holiday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 142880, 142),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 201496, 230),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129751, 126),
      ))
    }

@delegate:ResourceContentHash(795_497_757)
public val Res.string.forecast_basis_trading_sunday: StringResource by lazy {
      StringResource("string:forecast_basis_trading_sunday", "forecast_basis_trading_sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143023, 169),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 201727, 257),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129878, 145),
      ))
    }

@delegate:ResourceContentHash(-1_307_453_712)
public val Res.string.forecast_basis_weekday: StringResource by lazy {
      StringResource("string:forecast_basis_weekday", "forecast_basis_weekday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143193, 122),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 201985, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130024, 118),
      ))
    }

@delegate:ResourceContentHash(-1_585_850_800)
public val Res.string.forecast_headcount: StringResource by lazy {
      StringResource("string:forecast_headcount", "forecast_headcount", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143365, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 202233, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130196, 98),
      ))
    }

@delegate:ResourceContentHash(1_124_926_055)
public val Res.string.forecast_headcount_slots: StringResource by lazy {
      StringResource("string:forecast_headcount_slots", "forecast_headcount_slots", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143316, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 202180, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130143, 52),
      ))
    }

@delegate:ResourceContentHash(2_019_012_533)
public val Res.string.forecast_rate_goal: StringResource by lazy {
      StringResource("string:forecast_rate_goal", "forecast_rate_goal", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143480, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 202408, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130295, 42),
      ))
    }

@delegate:ResourceContentHash(-2_106_489_571)
public val Res.string.forecast_rate_history: StringResource by lazy {
      StringResource("string:forecast_rate_history", "forecast_rate_history", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143523, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 202459, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130338, 53),
      ))
    }

@delegate:ResourceContentHash(828_395_567)
public val Res.string.forecast_suggested: StringResource by lazy {
      StringResource("string:forecast_suggested", "forecast_suggested", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143585, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 202541, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130392, 58),
      ))
    }

@delegate:ResourceContentHash(1_596_497_773)
public val Res.string.forecast_trend: StringResource by lazy {
      StringResource("string:forecast_trend", "forecast_trend", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143724, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 202732, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130519, 66),
      ))
    }

@delegate:ResourceContentHash(-827_419_944)
public val Res.string.forecast_trend_none: StringResource by lazy {
      StringResource("string:forecast_trend_none", "forecast_trend_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143644, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 202628, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130451, 67),
      ))
    }

@delegate:ResourceContentHash(1_506_115_174)
public val Res.string.forecast_use: StringResource by lazy {
      StringResource("string:forecast_use", "forecast_use", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143856, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 202928, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130639, 24),
      ))
    }

@delegate:ResourceContentHash(1_344_194_305)
public val Res.string.forecast_use_all: StringResource by lazy {
      StringResource("string:forecast_use_all", "forecast_use_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143795, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 202823, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130586, 52),
      ))
    }

@delegate:ResourceContentHash(-1_715_678_530)
public val Res.string.frequency_monthly: StringResource by lazy {
      StringResource("string:frequency_monthly", "frequency_monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143885, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 202981, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130664, 37),
      ))
    }

@delegate:ResourceContentHash(-1_652_351_337)
public val Res.string.frequency_one_off: StringResource by lazy {
      StringResource("string:frequency_one_off", "frequency_one_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143927, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 203031, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130702, 37),
      ))
    }

@delegate:ResourceContentHash(-277_014_717)
public val Res.string.frequency_weekly: StringResource by lazy {
      StringResource("string:frequency_weekly", "frequency_weekly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 143969, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 203073, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130740, 32),
      ))
    }

@delegate:ResourceContentHash(-1_993_925_654)
public val Res.string.frequency_yearly: StringResource by lazy {
      StringResource("string:frequency_yearly", "frequency_yearly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 144010, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 203118, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130773, 32),
      ))
    }

@delegate:ResourceContentHash(1_698_614_938)
public val Res.string.group_managers_add: StringResource by lazy {
      StringResource("string:group_managers_add", "group_managers_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 144047, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 203159, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130806, 50),
      ))
    }

@delegate:ResourceContentHash(946_366_734)
public val Res.string.group_managers_error_malformed: StringResource by lazy {
      StringResource("string:group_managers_error_malformed", "group_managers_error_malformed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 144106, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 203242, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130857, 90),
      ))
    }

@delegate:ResourceContentHash(-129_690_620)
public val Res.string.group_managers_error_not_in_business: StringResource by lazy {
      StringResource("string:group_managers_error_not_in_business", "group_managers_error_not_in_business", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 144189, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 203369, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130948, 108),
      ))
    }

@delegate:ResourceContentHash(504_915_303)
public val Res.string.group_managers_error_not_signed_up: StringResource by lazy {
      StringResource("string:group_managers_error_not_signed_up", "group_managers_error_not_signed_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 144294, 174),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 203518, 238),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131057, 166),
      ))
    }

@delegate:ResourceContentHash(-2_111_437_740)
public val Res.string.group_managers_error_not_your_group: StringResource by lazy {
      StringResource("string:group_managers_error_not_your_group", "group_managers_error_not_your_group", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 144469, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 203757, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131224, 99),
      ))
    }

@delegate:ResourceContentHash(26_879_526)
public val Res.string.group_managers_error_owner: StringResource by lazy {
      StringResource("string:group_managers_error_owner", "group_managers_error_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 144577, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 203901, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131324, 98),
      ))
    }

@delegate:ResourceContentHash(-1_712_326_507)
public val Res.string.group_managers_error_too_many_workplaces: StringResource by lazy {
      StringResource("string:group_managers_error_too_many_workplaces", "group_managers_error_too_many_workplaces", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 144688, 112),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 204040, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131423, 116),
      ))
    }

@delegate:ResourceContentHash(1_979_146_283)
public val Res.string.group_managers_hint: StringResource by lazy {
      StringResource("string:group_managers_hint", "group_managers_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 144801, 143),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 204193, 227),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131540, 131),
      ))
    }

@delegate:ResourceContentHash(-1_962_536_395)
public val Res.string.group_managers_level: StringResource by lazy {
      StringResource("string:group_managers_level", "group_managers_level", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 144945, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 204421, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131672, 44),
      ))
    }

@delegate:ResourceContentHash(-384_603_799)
public val Res.string.group_managers_no_candidates: StringResource by lazy {
      StringResource("string:group_managers_no_candidates", "group_managers_no_candidates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 144990, 196),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 204486, 304),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131717, 164),
      ))
    }

@delegate:ResourceContentHash(57_054_638)
public val Res.string.group_managers_none: StringResource by lazy {
      StringResource("string:group_managers_none", "group_managers_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 145187, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 204791, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131882, 71),
      ))
    }

@delegate:ResourceContentHash(608_521_990)
public val Res.string.group_managers_person: StringResource by lazy {
      StringResource("string:group_managers_person", "group_managers_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 145267, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 204899, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131954, 37),
      ))
    }

@delegate:ResourceContentHash(-414_683_747)
public val Res.string.group_managers_remove: StringResource by lazy {
      StringResource("string:group_managers_remove", "group_managers_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 145495, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 205231, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132174, 77),
      ))
    }

@delegate:ResourceContentHash(-1_416_689_443)
public val Res.string.group_managers_remove_confirm: StringResource by lazy {
      StringResource("string:group_managers_remove_confirm", "group_managers_remove_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 145305, 189),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 204945, 285),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131992, 181),
      ))
    }

@delegate:ResourceContentHash(676_247_324)
public val Res.string.group_managers_saved: StringResource by lazy {
      StringResource("string:group_managers_saved", "group_managers_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 145577, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 205337, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132252, 56),
      ))
    }

@delegate:ResourceContentHash(1_900_168_353)
public val Res.string.group_managers_title: StringResource by lazy {
      StringResource("string:group_managers_title", "group_managers_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 145642, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 205434, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132309, 48),
      ))
    }

@delegate:ResourceContentHash(-1_747_220_735)
public val Res.string.group_settings_error_footer: StringResource by lazy {
      StringResource("string:group_settings_error_footer", "group_settings_error_footer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 145695, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 205503, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132358, 107),
      ))
    }

@delegate:ResourceContentHash(-1_687_873_839)
public val Res.string.group_settings_error_invalid: StringResource by lazy {
      StringResource("string:group_settings_error_invalid", "group_settings_error_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 145807, 140),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 205663, 216),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132466, 128),
      ))
    }

@delegate:ResourceContentHash(-86_862_731)
public val Res.string.group_settings_error_no_group: StringResource by lazy {
      StringResource("string:group_settings_error_no_group", "group_settings_error_no_group", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 145948, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 205880, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132595, 77),
      ))
    }

@delegate:ResourceContentHash(1_195_433_213)
public val Res.string.group_settings_error_not_finances: StringResource by lazy {
      StringResource("string:group_settings_error_not_finances", "group_settings_error_not_finances", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 146038, 149),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 206010, 221),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132673, 141),
      ))
    }

@delegate:ResourceContentHash(1_932_899_925)
public val Res.string.group_settings_error_plan_ended: StringResource by lazy {
      StringResource("string:group_settings_error_plan_ended", "group_settings_error_plan_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 146188, 127),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 206232, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132815, 123),
      ))
    }

@delegate:ResourceContentHash(2_146_707_310)
public val Res.string.group_settings_following_count: StringResource by lazy {
      StringResource("string:group_settings_following_count", "group_settings_following_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 146316, 98),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 206424, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132939, 110),
      ))
    }

@delegate:ResourceContentHash(-2_142_794_436)
public val Res.string.group_settings_intro: StringResource by lazy {
      StringResource("string:group_settings_intro", "group_settings_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 146415, 320),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 206591, 532),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133050, 272),
      ))
    }

@delegate:ResourceContentHash(1_913_401_767)
public val Res.string.group_settings_make_own: StringResource by lazy {
      StringResource("string:group_settings_make_own", "group_settings_make_own", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 146736, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 207124, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133323, 55),
      ))
    }

@delegate:ResourceContentHash(1_388_987_813)
public val Res.string.group_settings_open: StringResource by lazy {
      StringResource("string:group_settings_open", "group_settings_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 146788, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 207200, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133379, 47),
      ))
    }

@delegate:ResourceContentHash(-1_667_539_767)
public val Res.string.group_settings_own_done: StringResource by lazy {
      StringResource("string:group_settings_own_done", "group_settings_own_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 146840, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 207276, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133427, 83),
      ))
    }

@delegate:ResourceContentHash(-1_486_846_548)
public val Res.string.group_settings_placeholder_hint: StringResource by lazy {
      StringResource("string:group_settings_placeholder_hint", "group_settings_placeholder_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 146924, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 207412, 195),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133511, 91),
      ))
    }

@delegate:ResourceContentHash(-44_906_939)
public val Res.string.group_settings_reset: StringResource by lazy {
      StringResource("string:group_settings_reset", "group_settings_reset", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 147110, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 207718, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133681, 48),
      ))
    }

@delegate:ResourceContentHash(-1_599_755_317)
public val Res.string.group_settings_reset_done: StringResource by lazy {
      StringResource("string:group_settings_reset_done", "group_settings_reset_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 147036, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 207608, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133603, 77),
      ))
    }

@delegate:ResourceContentHash(-1_782_571_298)
public val Res.string.group_settings_saved_all: StringResource by lazy {
      StringResource("string:group_settings_saved_all", "group_settings_saved_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 147175, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 207819, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133730, 104),
      ))
    }

@delegate:ResourceContentHash(-37_494_466)
public val Res.string.group_settings_saved_some_own: StringResource by lazy {
      StringResource("string:group_settings_saved_some_own", "group_settings_saved_some_own", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 147284, 153),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 208004, 261),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133835, 149),
      ))
    }

@delegate:ResourceContentHash(1_381_960_525)
public val Res.string.group_settings_source_group: StringResource by lazy {
      StringResource("string:group_settings_source_group", "group_settings_source_group", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 147438, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 208266, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133985, 63),
      ))
    }

@delegate:ResourceContentHash(1_126_531_183)
public val Res.string.group_settings_source_own: StringResource by lazy {
      StringResource("string:group_settings_source_own", "group_settings_source_own", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 147506, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 208358, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134049, 49),
      ))
    }

@delegate:ResourceContentHash(-185_097_829)
public val Res.string.group_settings_templates_from: StringResource by lazy {
      StringResource("string:group_settings_templates_from", "group_settings_templates_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 147564, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 208444, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134099, 73),
      ))
    }

@delegate:ResourceContentHash(-1_657_492_975)
public val Res.string.group_settings_templates_hint: StringResource by lazy {
      StringResource("string:group_settings_templates_hint", "group_settings_templates_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 147642, 249),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 208558, 401),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134173, 265),
      ))
    }

@delegate:ResourceContentHash(131_160_357)
public val Res.string.group_settings_templates_title: StringResource by lazy {
      StringResource("string:group_settings_templates_title", "group_settings_templates_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 147892, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 208960, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134439, 58),
      ))
    }

@delegate:ResourceContentHash(1_388_987_813)
public val Res.string.group_settings_title: StringResource by lazy {
      StringResource("string:group_settings_title", "group_settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 147951, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 209035, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134498, 48),
      ))
    }

@delegate:ResourceContentHash(-527_441_294)
public val Res.string.help_about: StringResource by lazy {
      StringResource("string:help_about", "help_about", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 148004, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 209112, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134547, 34),
      ))
    }

@delegate:ResourceContentHash(719_580_029)
public val Res.string.help_centre: StringResource by lazy {
      StringResource("string:help_centre", "help_centre", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 148202, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 209406, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134737, 35),
      ))
    }

@delegate:ResourceContentHash(-351_053_669)
public val Res.string.help_centre_desc: StringResource by lazy {
      StringResource("string:help_centre_desc", "help_centre_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 148039, 128),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 209159, 200),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134582, 120),
      ))
    }

@delegate:ResourceContentHash(1_624_911_059)
public val Res.string.help_centre_title: StringResource by lazy {
      StringResource("string:help_centre_title", "help_centre_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 148168, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 209360, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134703, 33),
      ))
    }

@delegate:ResourceContentHash(1_515_746_945)
public val Res.string.help_got_it: StringResource by lazy {
      StringResource("string:help_got_it", "help_got_it", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 148242, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 209470, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134773, 27),
      ))
    }

@delegate:ResourceContentHash(-1_530_471_984)
public val Res.string.hint_blood_donation: StringResource by lazy {
      StringResource("string:hint_blood_donation", "hint_blood_donation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 148274, 171),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 209514, 207),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134801, 147),
      ))
    }

@delegate:ResourceContentHash(-483_867_338)
public val Res.string.hint_carer_leave: StringResource by lazy {
      StringResource("string:hint_carer_leave", "hint_carer_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 148446, 268),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 209722, 396),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134949, 188),
      ))
    }

@delegate:ResourceContentHash(-1_607_968_748)
public val Res.string.hint_childcare_leave: StringResource by lazy {
      StringResource("string:hint_childcare_leave", "hint_childcare_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 148715, 188),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 210119, 240),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135138, 132),
      ))
    }

@delegate:ResourceContentHash(1_547_839_632)
public val Res.string.hint_paternity: StringResource by lazy {
      StringResource("string:hint_paternity", "hint_paternity", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 148904, 214),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 210360, 278),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135271, 154),
      ))
    }

@delegate:ResourceContentHash(909_409_901)
public val Res.string.hint_time_off_in_lieu: StringResource by lazy {
      StringResource("string:hint_time_off_in_lieu", "hint_time_off_in_lieu", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 149119, 209),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 210639, 317),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135426, 189),
      ))
    }

@delegate:ResourceContentHash(792_777_042)
public val Res.string.hint_weeks: StringResource by lazy {
      StringResource("string:hint_weeks", "hint_weeks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 149329, 106),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 210957, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135616, 90),
      ))
    }

@delegate:ResourceContentHash(394_344_886)
public val Res.string.hiring_applicants: StringResource by lazy {
      StringResource("string:hiring_applicants", "hiring_applicants", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 149504, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 211180, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135775, 41),
      ))
    }

@delegate:ResourceContentHash(-705_827_976)
public val Res.string.hiring_applicants_count: StringResource by lazy {
      StringResource("string:hiring_applicants_count", "hiring_applicants_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 149436, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 211092, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135707, 67),
      ))
    }

@delegate:ResourceContentHash(-543_772_373)
public val Res.string.hiring_edit: StringResource by lazy {
      StringResource("string:hiring_edit", "hiring_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 149542, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 211230, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135817, 39),
      ))
    }

@delegate:ResourceContentHash(396_303_482)
public val Res.string.hiring_empty: StringResource by lazy {
      StringResource("string:hiring_empty", "hiring_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 149586, 196),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 211302, 244),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135857, 148),
      ))
    }

@delegate:ResourceContentHash(784_450_734)
public val Res.string.hiring_new_post: StringResource by lazy {
      StringResource("string:hiring_new_post", "hiring_new_post", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 149783, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 211547, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136006, 39),
      ))
    }

@delegate:ResourceContentHash(1_179_730_184)
public val Res.string.hiring_open: StringResource by lazy {
      StringResource("string:hiring_open", "hiring_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 149831, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 211607, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136046, 27),
      ))
    }

@delegate:ResourceContentHash(906_159_704)
public val Res.string.hiring_recruiter_empty: StringResource by lazy {
      StringResource("string:hiring_recruiter_empty", "hiring_recruiter_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 149867, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 211667, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136074, 82),
      ))
    }

@delegate:ResourceContentHash(-1_870_974_134)
public val Res.string.hiring_status_closed: StringResource by lazy {
      StringResource("string:hiring_status_closed", "hiring_status_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 149946, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 211798, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136157, 36),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString17Resources(map: MutableMap<String, StringResource>) {
  map.put("file_drop_only_one", Res.string.file_drop_only_one)
  map.put("file_drop_skipped", Res.string.file_drop_skipped)
  map.put("file_drop_wrong_type", Res.string.file_drop_wrong_type)
  map.put("file_drop_wrong_types", Res.string.file_drop_wrong_types)
  map.put("financials_actual_to_date", Res.string.financials_actual_to_date)
  map.put("financials_comparison", Res.string.financials_comparison)
  map.put("financials_cost_breakdown", Res.string.financials_cost_breakdown)
  map.put("financials_empty", Res.string.financials_empty)
  map.put("financials_estimate_note", Res.string.financials_estimate_note)
  map.put("financials_fixed_costs", Res.string.financials_fixed_costs)
  map.put("financials_health", Res.string.financials_health)
  map.put("financials_labor_costs", Res.string.financials_labor_costs)
  map.put("financials_labor_costs_note", Res.string.financials_labor_costs_note)
  map.put("financials_labor_value", Res.string.financials_labor_value)
  map.put("financials_labor_value_income", Res.string.financials_labor_value_income)
  map.put("financials_no_roster", Res.string.financials_no_roster)
  map.put("financials_other_costs", Res.string.financials_other_costs)
  map.put("financials_roster", Res.string.financials_roster)
  map.put("financials_select_roster", Res.string.financials_select_roster)
  map.put("financials_show_daily_records", Res.string.financials_show_daily_records)
  map.put("financials_show_payroll", Res.string.financials_show_payroll)
  map.put("financials_total_expenses", Res.string.financials_total_expenses)
  map.put("first_steps_dismiss", Res.string.first_steps_dismiss)
  map.put("first_steps_done", Res.string.first_steps_done)
  map.put("first_steps_progress", Res.string.first_steps_progress)
  map.put("first_steps_to_do", Res.string.first_steps_to_do)
  map.put("forecast_accepted", Res.string.forecast_accepted)
  map.put("forecast_banner", Res.string.forecast_banner)
  map.put("forecast_basis_holiday", Res.string.forecast_basis_holiday)
  map.put("forecast_basis_trading_sunday", Res.string.forecast_basis_trading_sunday)
  map.put("forecast_basis_weekday", Res.string.forecast_basis_weekday)
  map.put("forecast_headcount", Res.string.forecast_headcount)
  map.put("forecast_headcount_slots", Res.string.forecast_headcount_slots)
  map.put("forecast_rate_goal", Res.string.forecast_rate_goal)
  map.put("forecast_rate_history", Res.string.forecast_rate_history)
  map.put("forecast_suggested", Res.string.forecast_suggested)
  map.put("forecast_trend", Res.string.forecast_trend)
  map.put("forecast_trend_none", Res.string.forecast_trend_none)
  map.put("forecast_use", Res.string.forecast_use)
  map.put("forecast_use_all", Res.string.forecast_use_all)
  map.put("frequency_monthly", Res.string.frequency_monthly)
  map.put("frequency_one_off", Res.string.frequency_one_off)
  map.put("frequency_weekly", Res.string.frequency_weekly)
  map.put("frequency_yearly", Res.string.frequency_yearly)
  map.put("group_managers_add", Res.string.group_managers_add)
  map.put("group_managers_error_malformed", Res.string.group_managers_error_malformed)
  map.put("group_managers_error_not_in_business", Res.string.group_managers_error_not_in_business)
  map.put("group_managers_error_not_signed_up", Res.string.group_managers_error_not_signed_up)
  map.put("group_managers_error_not_your_group", Res.string.group_managers_error_not_your_group)
  map.put("group_managers_error_owner", Res.string.group_managers_error_owner)
  map.put("group_managers_error_too_many_workplaces", Res.string.group_managers_error_too_many_workplaces)
  map.put("group_managers_hint", Res.string.group_managers_hint)
  map.put("group_managers_level", Res.string.group_managers_level)
  map.put("group_managers_no_candidates", Res.string.group_managers_no_candidates)
  map.put("group_managers_none", Res.string.group_managers_none)
  map.put("group_managers_person", Res.string.group_managers_person)
  map.put("group_managers_remove", Res.string.group_managers_remove)
  map.put("group_managers_remove_confirm", Res.string.group_managers_remove_confirm)
  map.put("group_managers_saved", Res.string.group_managers_saved)
  map.put("group_managers_title", Res.string.group_managers_title)
  map.put("group_settings_error_footer", Res.string.group_settings_error_footer)
  map.put("group_settings_error_invalid", Res.string.group_settings_error_invalid)
  map.put("group_settings_error_no_group", Res.string.group_settings_error_no_group)
  map.put("group_settings_error_not_finances", Res.string.group_settings_error_not_finances)
  map.put("group_settings_error_plan_ended", Res.string.group_settings_error_plan_ended)
  map.put("group_settings_following_count", Res.string.group_settings_following_count)
  map.put("group_settings_intro", Res.string.group_settings_intro)
  map.put("group_settings_make_own", Res.string.group_settings_make_own)
  map.put("group_settings_open", Res.string.group_settings_open)
  map.put("group_settings_own_done", Res.string.group_settings_own_done)
  map.put("group_settings_placeholder_hint", Res.string.group_settings_placeholder_hint)
  map.put("group_settings_reset", Res.string.group_settings_reset)
  map.put("group_settings_reset_done", Res.string.group_settings_reset_done)
  map.put("group_settings_saved_all", Res.string.group_settings_saved_all)
  map.put("group_settings_saved_some_own", Res.string.group_settings_saved_some_own)
  map.put("group_settings_source_group", Res.string.group_settings_source_group)
  map.put("group_settings_source_own", Res.string.group_settings_source_own)
  map.put("group_settings_templates_from", Res.string.group_settings_templates_from)
  map.put("group_settings_templates_hint", Res.string.group_settings_templates_hint)
  map.put("group_settings_templates_title", Res.string.group_settings_templates_title)
  map.put("group_settings_title", Res.string.group_settings_title)
  map.put("help_about", Res.string.help_about)
  map.put("help_centre", Res.string.help_centre)
  map.put("help_centre_desc", Res.string.help_centre_desc)
  map.put("help_centre_title", Res.string.help_centre_title)
  map.put("help_got_it", Res.string.help_got_it)
  map.put("hint_blood_donation", Res.string.hint_blood_donation)
  map.put("hint_carer_leave", Res.string.hint_carer_leave)
  map.put("hint_childcare_leave", Res.string.hint_childcare_leave)
  map.put("hint_paternity", Res.string.hint_paternity)
  map.put("hint_time_off_in_lieu", Res.string.hint_time_off_in_lieu)
  map.put("hint_weeks", Res.string.hint_weeks)
  map.put("hiring_applicants", Res.string.hiring_applicants)
  map.put("hiring_applicants_count", Res.string.hiring_applicants_count)
  map.put("hiring_edit", Res.string.hiring_edit)
  map.put("hiring_empty", Res.string.hiring_empty)
  map.put("hiring_new_post", Res.string.hiring_new_post)
  map.put("hiring_open", Res.string.hiring_open)
  map.put("hiring_recruiter_empty", Res.string.hiring_recruiter_empty)
  map.put("hiring_status_closed", Res.string.hiring_status_closed)
}
